export const metaRequireAuth = {
  authenticated: true,
};

export const metaRequireGuest = {
  guest: true,
};
